import React, {useContext} from 'react';
import {Navigate, useLocation} from 'react-router-dom'
import Spinner from '../components/Spinner/index';
import FirebaseContext from "../context/FirebaseContext";
import './Splash.scss';

function RequireAuth({ children, anonymous }) {
  const firebase = useContext(FirebaseContext);
  const {user, userLoading} = firebase;
  let location = useLocation();

  // regardless of loading indicator, if we have a user, go ahead with content
  if (user) {
    return children;
  }

  if (userLoading) {
    return <div className="splash-screen">
      <Spinner />
    </div>
  } else if (!user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return anonymous || <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
export default RequireAuth;